import { Colors } from '../consts/Colors'

export const TextContents = {
    popup: {
        text: "Pour la troisième étape, replacez les éléments constitutifs d'une trésorerie active et d'une trésorerie passive.",
    },
    consigne: {
        text: "Replacez les éléments constitutifs d'une trésorerie active et d'une trésorerie passive.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 381 }
    },
    title : {
        text : "TRÉSORERIE NETTE, FONDS DE ROULEMENT ET BESOIN EN FONDS DE ROULEMENT",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique24\'>ÉTAPE 3 :</class> Trésorerie active et Trésorerie passive",
        config: { size: '24px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    bravo : {
        text: "Vous avez correctement replacé les éléments constitutifs d'une trésorerie active et d'une trésorerie passive."
    }
}

export const CartesInfos = [
    {
        titre: "Confidentielle",
        image: "besoinTresorerie",
        placeholder: "placeholder3_1",
        zoneId: 4,
        scale: 1,
        cardX: 0,
        cardY: -227
    },
    {
        titre: "Non Confidentielle",
        image: "schemaBesoinTresorerie",
        placeholder: "placeholder3_3",
        zoneId: 3,
        scale: 0.8,
        cardX: -110,
        cardY: 80
    },
    {
        titre: "Gel des dettes",
        image: "excedentTresorerie",
        placeholder: "placeholder3_1",
        zoneId: 2,
        scale: 1,
        cardX: 0,
        cardY: -110
    },
    {
        titre: "Continue ses engagements",
        image: "schemaExcedentTresorerie",
        placeholder: "placeholder3_4",
        zoneId: 1,
        scale: 0.8,
        cardX: 70,
        cardY: 76
    },
]
export const ZonesInfos = [
    {
        zoneX: 465,
        zoneY: 327,
        zoneId: 1,
        image: "imgPlaceholderBig",
    },
    {
        zoneX: 465,
        zoneY: 510,
        zoneId: 2,
        image: "labelPlaceholder",
    },
    {
        zoneX: 964,
        zoneY: 327,
        zoneId: 3,
        image: "imgPlaceholderBig",
    },
    {
        zoneX: 964,
        zoneY: 510,
        zoneId: 4,
        image: "labelPlaceholder",
    },
]